import { GlobalSearchResultsListStyled } from './styles/GlobalSearchResultsListStyled'
import { type GlobalSearchResultItem } from '../../../../value-objects/GlobalSearchResultItem'
import { GlobalSearchListItem } from '../GlobalSearchListItem'

interface IGlobalSearchResultsListProps {
  items: GlobalSearchResultItem[]
  onResultItemClick: (item: GlobalSearchResultItem) => void
}

export const GlobalSearchResultsList = ({
  items,
  onResultItemClick,
}: IGlobalSearchResultsListProps) => {
  return (
    <GlobalSearchResultsListStyled>
      {items.map((item) => (
        <GlobalSearchListItem
          key={item.uuid}
          type={item.type}
          id={item.id}
          metadata={item.metadata}
          extraIdentifier={item.label}
          onClick={() => onResultItemClick(item)}
        />
      ))}
    </GlobalSearchResultsListStyled>
  )
}
